export default __webpack_public_path__ + "static/Montserrat-Bold-6aab475a7e27a6f02aed4498745dbafa.woff2";